export default __webpack_public_path__ + "static/media/dom-parse.25226f4f.gif";